module.exports = __webpack_public_path__ + "static/flutterwave-home-a168524aa8baebaba158760ee5f83aa1.png";